import React, { createContext, useState, useContext, ReactNode } from 'react';
import { useAuthFrontLock } from './useAuthFrontContext';
import { PAGE_NAME, PAGE_NAME_CONSTANT } from '../utils/constant/constant';
import { getCurrentPageCookie } from '../utils/utils/utils';

// Define the shape of your context
type ScreenContextType = {
    displayScreen: string;
    setDisplayScreen: React.Dispatch<React.SetStateAction<string>>;
};

// Create the context with an initial value of undefined
export const ScreenContext = createContext<ScreenContextType | undefined>(undefined);

// Create a provider component
export const ScreenProvider = ({ children }: { children: ReactNode }) => {
    const authFrontLock = useAuthFrontLock();

    const { screenId = 0 } = authFrontLock?.getAdditionalParams() || {};
    const screenTypeFromParams = authFrontLock.getScreenType() || '';
    
    const { currentScreenId, currentScreenType: screenTypeFromCookie} = getCurrentPageCookie();

    let screenType = PAGE_NAME.SIGN_IN;
    if(currentScreenId >= screenId && PAGE_NAME_CONSTANT.includes(screenTypeFromCookie)) {
        screenType = screenTypeFromCookie;
    } else if (PAGE_NAME_CONSTANT.includes(screenTypeFromParams)) {
        screenType = screenTypeFromParams;
    }

    const [displayScreen, setDisplayScreen] = useState(screenType);

    return (
        <ScreenContext.Provider value={{ displayScreen, setDisplayScreen }}>
            {children}
        </ScreenContext.Provider>
    );
};

// Custom hook to use the context
export const useScreen = () => {
    const context = useContext(ScreenContext);
    if (!context) {
        throw new Error('useScreen must be used within a ScreenProvider');
    }
    return context;
};
